(() => {
  let sequence = 0;
  const instances = new Set();
  const enhance = () => {
    document.querySelectorAll('select[data-outfit-variant], variant-selects select, .product-form__input select').forEach(select => {
      if (select.dataset.arwEnhanced) return;
      select.dataset.arwEnhanced = 'true';
      const button = document.createElement('button');
      const list = document.createElement('div');
      const label = select.labels?.[0]?.textContent.trim() || select.getAttribute('aria-label') || select.name;
      button.type = 'button';
      button.className = 'arw-select-trigger';
      button.setAttribute('role', 'combobox');
      button.setAttribute('aria-haspopup', 'listbox');
      button.setAttribute('aria-expanded', 'false');
      list.id = `arw-select-${++sequence}`;
      list.className = 'arw-select-menu';
      list.setAttribute('role', 'listbox');
      list.setAttribute('aria-label', label);
      list.hidden = true;
      button.setAttribute('aria-controls', list.id);
      select.after(button);
      document.body.append(list);
      select.classList.add('arw-select-native');
      let active = -1;
      let options = [];
      const sync = () => {
        button.textContent = select.selectedOptions[0]?.textContent.trim() || '';
        button.setAttribute('aria-label', `${label}: ${button.textContent}`);
        button.disabled = select.disabled;
      };
      const close = () => {
        list.hidden = true;
        button.setAttribute('aria-expanded', 'false');
        button.removeAttribute('aria-activedescendant');
      };
      const place = () => {
        const rect = button.getBoundingClientRect();
        const roomBelow = window.innerHeight - rect.bottom - 12;
        const above = roomBelow < 210 && rect.top > roomBelow;
        list.style.width = `${Math.min(rect.width, window.innerWidth - 24)}px`;
        list.style.left = `${Math.max(12, Math.min(rect.left, window.innerWidth - rect.width - 12))}px`;
        list.style.maxHeight = `${Math.min(320, Math.max(100, (above ? rect.top : roomBelow) - 12))}px`;
        list.style.top = above ? 'auto' : `${rect.bottom + 7}px`;
        list.style.bottom = above ? `${window.innerHeight - rect.top + 7}px` : 'auto';
      };
      const highlight = index => {
        active = index;
        options.forEach((option, i) => option.classList.toggle('is-active', i === active));
        if (options[active]) {
          button.setAttribute('aria-activedescendant', options[active].id);
          options[active].scrollIntoView({block:'nearest'});
        }
      };
      const choose = index => {
        if (select.disabled || select.options[index].disabled) return;
        select.selectedIndex = index;
        close();
        sync();
        select.dispatchEvent(new Event('change', {bubbles:true}));
        button.focus();
      };
      const open = () => {
        if (button.disabled) return;
        instances.forEach(instance => instance.close());
        list.replaceChildren();
        options = Array.from(select.options, (option, index) => {
          const item = document.createElement('div');
          item.id = `${list.id}-${index}`;
          item.setAttribute('role', 'option');
          item.setAttribute('aria-selected', String(option.selected));
          item.setAttribute('aria-disabled', String(option.disabled));
          item.textContent = option.textContent.trim();
          item.addEventListener('mousedown', event => event.preventDefault());
          item.addEventListener('click', () => choose(index));
          list.append(item);
          return item;
        });
        place();
        list.hidden = false;
        button.setAttribute('aria-expanded', 'true');
        highlight(select.selectedIndex);
      };
      button.addEventListener('click', () => list.hidden ? open() : close());
      let search = '', searchTimer;
      button.addEventListener('keydown', event => {
        if (event.key === 'Escape') { close(); event.preventDefault(); return; }
        if (event.key === 'Tab') { close(); return; }
        if (['ArrowDown','ArrowUp','Home','End'].includes(event.key)) {
          event.preventDefault();
          if (list.hidden) open();
          const enabled = Array.from(select.options).map((o,i) => o.disabled ? -1 : i).filter(i => i >= 0);
          let position = enabled.indexOf(active);
          position = event.key === 'Home' ? 0 : event.key === 'End' ? enabled.length - 1 : Math.max(0, Math.min(enabled.length - 1, position + (event.key === 'ArrowDown' ? 1 : -1)));
          if (enabled.length) highlight(enabled[position]);
        } else if ((event.key === 'Enter' || event.key === ' ') && !list.hidden) {
          event.preventDefault();
          if (active >= 0) choose(active);
        } else if (event.key.length === 1 && event.key !== ' ') {
          if (list.hidden) open();
          search += event.key.toLocaleLowerCase();
          clearTimeout(searchTimer);
          searchTimer = setTimeout(() => search = '', 700);
          const index = Array.from(select.options).findIndex(o => !o.disabled && o.textContent.trim().toLocaleLowerCase().startsWith(search));
          if (index >= 0) highlight(index);
        }
      });
      button.addEventListener('blur', close);
      select.addEventListener('change', sync);
      const observer = new MutationObserver(sync);
      observer.observe(select, {attributes:true, childList:true, subtree:true});
      instances.add({select, button, list, close, sync, observer});
      sync();
    });
    instances.forEach(instance => {
      if (!instance.select.isConnected) {
        instance.list.remove();
        instance.observer.disconnect();
        instances.delete(instance);
      }
    });
  };
  document.addEventListener('pointerdown', event => instances.forEach(i => {
    if (!i.button.contains(event.target) && !i.list.contains(event.target)) i.close();
  }));
  window.addEventListener('resize', () => instances.forEach(i => i.close()));
  window.addEventListener('scroll', event => {
    if (!event.target?.closest?.('.arw-select-menu')) instances.forEach(i => i.close());
  }, true);
  window.addEventListener('pageshow', () => setTimeout(() => instances.forEach(i => i.sync()), 0));
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; enhance(); });
  }).observe(document.body, {childList:true, subtree:true});
  enhance();
})();
